import { render, staticRenderFns } from "./LkRegion.vue?vue&type=template&id=38a92fce&scoped=true&"
import script from "./LkRegion.vue?vue&type=script&lang=js&"
export * from "./LkRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a92fce",
  null
  
)

export default component.exports